import type { CheckoutFastFlowAction, CheckoutFastFlowState } from ".";

export const checkoutFastFlowReducer = (
  state: CheckoutFastFlowState,
  action: CheckoutFastFlowAction
): CheckoutFastFlowState => {
  switch (action.type) {
    case "READY":
      return state === "idle" ? "deciding" : state;
    case "RUN":
      return state === "deciding" ? "running" : state;
    case "COMPLETE":
      return state === "running" ? action.result : state;
    default:
      return state;
  }
};
